import { Flex, Text, Button } from '@skin-seoul/design-system';
import { useState } from 'react';
import TrackOrderModal from './TrackOrderModal';

const DeliveryTrackingBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTrackDelivery = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <Flex width="100%" backgroundColor="primary.600" alignItems="center" justifyContent="center">
      <Flex
        maxWidth="1280px"
        width="100%"
        paddingX={{ base: 4, tablet: 6, desktop: 10 }}
        paddingY={{ base: 3, tablet: 4 }}
        alignItems="center"
        justifyContent="space-between"
        gap={{ base: 3, tablet: 4 }}
        flexDirection={{ base: 'column', tablet: 'row' }}
      >
        <Text
          color="generic.0"
          textStyle={{ base: 'paragraph.medium', tablet: 'heading.h6' }}
          fontWeight="medium"
          letterSpacing="-0.4px"
          textAlign={{ base: 'center', tablet: 'left' }}
          flex={{ base: 'unset', tablet: '1' }}
        >
          Want to track your order as a guest?
        </Text>
        <Button
          onClick={handleTrackDelivery}
          backgroundColor="generic.0"
          color="primary.600"
          textStyle="label.large"
          fontWeight="semibold"
          paddingX={4}
          paddingY={2}
          borderRadius="8px"
          flexShrink={0}
          type="button"
        >
          Track Delivery
        </Button>
        <TrackOrderModal isOpen={isModalOpen} onClose={handleModalClose} />
      </Flex>
    </Flex>
  );
};

export default DeliveryTrackingBanner;
